import React, { useState } from "react";
import style from "../../sass/contact.module.scss";
import { ReactComponent as MailSend } from "../../helper/svgicon/Contact/MailSend.svg";
import { useNavigate } from "react-router-dom";
const Contact = () => {
     const navigate = useNavigate();

     const handleNavigation = () => {
          navigate("/");
     };

     return (
          <div className={style.contact}>
               <div className={style.contact_container}>
                    {/* <div className={style.contact_heading}>Contact Me</div> */}
                    <div className={style.contact_layout}>
                         <div className={style.contact_layout_image}>
                              <div>
                                   <MailSend />
                              </div>
                         </div>
                         <div className={style.contact_layout_details}>
                              <h2>Contact Me</h2>
                              <p>
                                   I am available on almost every social media. You can message me, I will reply within 24 hours. I can guide you about M.E.R.N. Stack Development.
                              </p>
                              <div className={style.contact_layout_details_button} onClick={handleNavigation}>
                                   <h4>Contact</h4>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
};
export default Contact;
